import React from 'react';
import ROUTES_NAME from '../consts/routes-name';

const AcessoNegadoView = React.lazy(() => import('../views/acesso-negado'));
const HomeView = React.lazy(() => import('../views/home'));
const DadosClienteView = React.lazy(() => import('../views/dados-cliente'));
const ListaBensView = React.lazy(() => import('../views/lista-bens'));
const ComboView = React.lazy(() => import('../views/combos'));
const CoberturaView = React.lazy(() => import('../views/cobertura'));
const ResumoView = React.lazy(() => import('../views/resumo'));
const PersonalizarView = React.lazy(() => import('../views/personalizar'));
const DadosComplementaresView = React.lazy(() => import('../views/dados-complementares'));
const ResumoSolicitacaoView = React.lazy(() => import('../views/resumo-solicitacao'));
const ContratacaoView = React.lazy(() => import('../views/contratacao'));
const SolicitacaoContratacaoView = React.lazy(() => import('../views/solicitacao-contratacao'));
const HistoricoView = React.lazy(() => import('../views/historico'));
const ErrorView = React.lazy(() => import('../views/error'));
const ListaBensEditView = React.lazy(() => import('../views/lista-bens-edit'));

// Array contendo as possíveis rotas da aplicação, sendo a rota "*" como a rota da página do erro 404.
const routes = [
    {
        path: '/',
        exact: true,
        component: HomeView
    },
    {
        path: ROUTES_NAME.HOME,
        exact: true,
        component: HomeView
    },
    {
        path: ROUTES_NAME.DADOS_CLIENTE,
        exact: true,
        component: DadosClienteView
    },
    {
        path: ROUTES_NAME.LISTA_BENS,
        exact: true,
        component: ListaBensView
    },
    {
        path: ROUTES_NAME.COMBOS,
        exact: true,
        component: ComboView
    },
    {
        path: ROUTES_NAME.COBERTURA,
        exact: true,
        component: CoberturaView
    },
    {
        path: ROUTES_NAME.RESUMO,
        exact: true,
        component: ResumoView
    },
    {
        path: ROUTES_NAME.PERSONALIZAR,
        exact: true,
        component: PersonalizarView
    },
    {
        path: ROUTES_NAME.DADOS_COMPLEMENTARES,
        exact: true,
        component: DadosComplementaresView
    },
    {
        path: ROUTES_NAME.RESUMO_SOLICITACAO,
        exact: true,
        component: ResumoSolicitacaoView
    },
    {
        path: ROUTES_NAME.CONTRATACAO,
        exact: true,
        component: ContratacaoView
    },
    {
        path: ROUTES_NAME.ACESSO_NEGADO,
        exact: true,
        component: AcessoNegadoView
    },
    {
        path: ROUTES_NAME.SOLICITACAO_CONTRATACAO,
        exact: true,
        component: SolicitacaoContratacaoView
    },
    {
        path: ROUTES_NAME.HISTORICO,
        exact: true,
        component: HistoricoView
    },
    {
        path: ROUTES_NAME.ATUALIZAR_ANO_BEM,
        exact: true,
        component: ListaBensEditView
    },
    {
        path: '*',
        exact: true,
        component: ErrorView
    }
];

export default routes;
